<template>
  <section class="form-container p-md-4 my-3 col-lg-5 col-md-7 col-10">
    <!-- User Registration Form -->
    <form @submit.prevent="submitForm" class="form-container py-4">
      <div class="text-center mb-4">
        <h2 v-if="userId" class="text-primary">المعلومات الشخصية</h2>
        <h2 v-else class="text-primary">معلومات حسابي</h2>
      </div>
      <div class="row mb-3">
        <div v-for="field in formFields" :key="field.id" class="col-md-6 mb-2">
          <label :for="field.id" class="form-label">{{ field.label }}</label>
          <select v-if="field.type == 'select'" class="form-select" :id="field.id" v-model="field.value"
            :required="field.required" :disabled="isDisabled">
            <option value="" data-hidden="true" :selected="(field.value) ? false : true" disabled>{{ field.placeholder
              }}
            </option>
            <option v-for="option in field.options" :key="option.id" :value="option.id">
              {{ option[field.optionName] }}
            </option>
          </select>
          <input v-else :type="field.type" class="form-control" :id="field.id" v-model="field.value"
            :required="field.required" :disabled="isDisabled" />
        </div>
      </div>
      <div v-if="!userId" class="">
        <a id="change-pass-btn" @click="initModal('changePassModal')" class="link">تغيير الرمز السري</a>
      </div>
      <!-- Submit Button -->
      <!-- <button type="submit" class="btn btn-primary w-100">
        تسجيل المستخدم
      </button> -->
    </form>
    <div class="d-flex w-100" v-if="isDisabled == true">
      <div class="col-md-3 col-6 my-2">
        <button @click="isDisabled = false" class="btn btn-success w-100 my-1 " type="button" :disabled="!getUser?.privs.includes('updateUser')">
          تعديل <font-awesome-icon icon="fa-regular fa-pen-to-square" />
        </button>
      </div>
      <div class="col-md-3 offset-md-6 col-6 my-2">
        <button @click="$router.go(-1)" class="btn btn-secondary w-100 my-1 " type="button">عودة
          <font-awesome-icon icon="fa-regular fa-circle-left" />
        </button>
      </div>
    </div>

    <div class="d-flex w-100" v-else>
      <div class="col-md-3 col-6 my-2">
        <button @click="initModal('confirmUpdateModal')" class="btn btn-primary w-100 my-1 " type="button">حفظ
          <font-awesome-icon icon="fa-solid fa-floppy-disk" />
        </button>
      </div>
      <div class="col-md-3 offset-md-6 col-6 my-2">
        <button @click="isDisabled = true" class="btn btn-secondary w-100 my-1 " type="button">إلغاء
          <font-awesome-icon icon="fa-regular fa-circle-xmark" />
        </button>
      </div>
    </div>
  </section>

  <GeneralModal :modalId="'changePassModal'" :modalTitle="'نغيير الرقم السري'" :modalFormLabel="''"
    :inputFields="changePassFields" :modalSubmitFnc="'newModalSubmit'" :dismissable="''" />
  <ConfirmModal :modalId="'confirmUpdateModal'" :confirmModalFnc="'updateUser'" :dismissable="''" />
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import GeneralModal from "@/components/Modal.vue";
import AlertModal from "@/components/AlertModal.vue";
import { Modal } from 'bootstrap';
import ConfirmModal from '../ConfirmModal.vue';
import router from '@/router/index.js';
export default {
  name: "ProfileForm",
  // props: {
  // },
  data() {
    return {
      changePassModal: {},
      confirmUpdateModal: {},
      userId: this.$route.params?.id ?? 0,
      user: {},
      isDisabled: true,
      changePassFields: [
        {
          id: "oldpass",
          model: "oldpass",
          type: "password",
          placeholder: 'الرمز السري الحالي',
          required: "required",
          value: ""
        },
        {
          id: "newpass",
          model: "newpass",
          type: "password",
          placeholder: "الرمز السري الجديد",
          value: "",
          required: "required",
        },
        {
          id: "repeatnewpass",
          model: "repeatnewpass",
          type: "password",
          placeholder: "أعد كتابة الرمز الجديد",
          value: "",
          required: "required",
        }
      ],
      formFields: {
        firstName: { id: 'firstName', label: 'الاسم الأول', type: 'text', value: "" },
        lastName: { id: 'lastName', label: 'اللقب', type: 'text', value: "" },
        empNo: { id: 'empNo', label: 'الرقم الوظيفي', type: 'text', value: "" },
        phoneNo: { id: 'phoneNo', label: 'رقم الهاتف', type: 'text', value: "" },
        email: { id: 'email', label: 'البريد الإلكتروني', type: 'email', value: "" },
        departId: {
          id: "departId",
          label: "القسم",
          type: 'select',
          value: "",
          options: [],
          optionName: "name",
          placeholder: "مركز الجمرك الحدودي",
        },
        groupId: {
          id: "groupId",
          label: "الوظيفة",
          type: 'select',
          value: "",
          options: [],
          optionName: "groupName",
          placeholder: "الصفة الوظيفية",
        },
      },
    }
  },
  computed: {
    ...mapGetters(['getDeparts', 'getGroups', 'getUser'])
  },
  components: {
    GeneralModal,
    AlertModal,
    ConfirmModal
  },
  created() {
    this.fetchOptions()
  },

  mounted() {
    this.changePassModal = new Modal(document.getElementById('changePassModal'));
    this.confirmUpdateModal = new Modal(document.getElementById('confirmUpdateModal'));
  },
  methods: {
    /** */
    ...mapActions([
      'fetchDeparts',
      'fetchGroups',
      'fetchUser',
    ]),
    /********************************/
    /** */
    async fetchOptions() {
      console.log(this.getDeparts)
      if (this.getDeparts.length == 0) {
        await this.fetchDeparts();
      }
      if (this.getGroups.length == 0) {
        await this.fetchGroups();
      }
      if(this.userId){
        try {
            const response = await this.$axios.post("api/employee/user/getuserbyid", {userId: this.userId});
            if(response.data.isSuccess){
              this.user = response.data.user
            }else{
              this.$tempAlert("فشل استجلاب بيانات الموظف", 'warning')
            }
          } catch (error) {
            this.$tempAlert(error.response.data.msg ?? "مشكلة في التصال", 'warning');
            console.error("Error fetching options:", error);
        }
      }else{
        if (this.getUser.hasOwnProperty("empNo")) {
          await this.fetchUser();
        }
        this.user = this.getUser
      }
      this.formFields.departId.options = this.getDeparts;
      this.formFields.groupId.options = this.getGroups;
      Object.keys(this.formFields).forEach(key => {
        this.formFields[key].value = this.user[key];
      });
    },
    /*********************************/
    /** */
    initModal(modalId) {
      this[modalId].show()
    },
    /*******************/
    /** */
    async newModalSubmit() {

      const reqDat = {
        oldpass : this.changePassFields[0].value,
        newpass : this.changePassFields[1].value
      }
      if(this.changePassFields[1].value == this.changePassFields[2].value)
      {
        try {
          const response = await this.$axios.post("api/employee/user/changepass", reqDat);
          const data = response.data;
          if (data.isSuccess) {
            this.$tempAlert(data.msg, 'success');
          } else {
            this.$tempAlert(data.msg, 'warning');
          }
        } catch (error) {
          this.$tempAlert(error.response.data.msg ?? "مشكلة في التصال", 'warning');
          console.error("Error fetching options:", error);
        }
        this.changePassModal.hide(); // To close the modal
      }else
      {
        this.$tempAlert("الرمز السري الجديد غير متطابق", 'warning');
      }
    },
    /*****************************/
    
    async updateUser() {

      if (!this.formFields.firstName.value || !this.formFields.lastName.value || !this.formFields.phoneNo.value || !this.formFields.groupId.value) {
        this.$tempAlert("يرجى ملء جميع الحقول المطلوبة!", "danger");
        return;
      }
      const formData = new FormData();
      // const reqData ={}
      formData.append('id', this.userId);
      Object.keys(this.formFields).forEach((key) => {
        if (key != "repeatPass") {
          formData.append(key, this.formFields[key].value);
          // reqData[key] = this.formFields[key].value
        }
      });

      try {
        const response = await this.$axios.post("api/employee/user/update", formData);
        if (response.data.isSuccess) {
          this.$tempAlert(response.data.msg ?? "تمت الإضافة بنجاح", "success");
        } else {
          this.$tempAlert(response.data.msg ?? "فشل العملية");
        }
        setTimeout(() => {
          router.go(0)
        }, 1000)
      } catch (error) {
        if (error.response?.data) {
          this.$tempAlert(error.response.data.msg, 'warning');
          var emsg = {
            msg: "",
            interval: 4000
          };
          error.response?.data.errors.forEach((e) => {
            emsg.msg += e + "<br/>";
            emsg.interval += 2000;
          })
          setTimeout(() => {
            this.$tempAlert(emsg.msg, 'warning', emsg.interval);
          }, 1000)
          setTimeout(() => {
          router.go(0)
        }, emsg.interval - 2000)
        }
        console.error("Submission error:", error);
      }      
        this.confirmUpdateModal.hide(); // To close the modal
    },
  }
}
</script>